
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { servicedCities } from "@/constants/cities";
import { Helmet } from "react-helmet-async";

const AreasWeServe = () => {
  return (
    <>
      <Helmet>
        <title>Areas We Serve | Mobile Auto Detailing | Mobile Detail Co.</title>
        <meta name="description" content="Professional mobile car detailing services throughout the Twin Cities Metro Area. Serving Minneapolis, St. Paul, and surrounding suburbs." />
        <link rel="canonical" href="https://mobiledetailco.com/areas-we-serve" />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-b from-white to-primary-light pt-24">
        <div className="container mx-auto px-4 py-12">
          <h1 className="text-4xl md:text-6xl font-bold text-primary text-center mb-6">
            Areas We Serve
          </h1>
          <p className="text-xl text-gray-600 text-center mb-12">
            Professional Mobile Car Detailing Services Throughout the Twin Cities Metro Area
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {servicedCities.map((city) => (
              <Link key={city.path} to={city.path}>
                <Card className="p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <h2 className="text-2xl font-semibold text-primary mb-2">{city.name}</h2>
                  <p className="text-gray-600">
                    Premium mobile detailing services in {city.name}
                  </p>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AreasWeServe;
